import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export type ProDriverDrawerRecord = NonNullable<
  ResultOf<typeof proDriverDrawerQuery>["proDriver"]
>;

export const proDriverDrawerQuery = graphql(`
  query ProDriverDrawer($id: ID!) {
    proDriver(id: $id) {
      id
      name
      email
      phone
      bio
      date_of_birth
      rating
      numberOfReviews
      numberOfCompletedAssignments
      license_type
      license_number
      license_issuer
      tax_registration
      business_registration_number
      bank_name
      bank_account_name
      bank_account_number
      bank_identifier_code
      has_tow_vehicle
      tow_vehicle_type
      tow_vehicle_year
      tow_capacity_kg
      basedIn {
        id
        name
        state
      }
    }
  }
`);
